// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bSEE","title":"styles_title__I5tBk"};